// extracted by mini-css-extract-plugin
export default {"empty":"EmptyList_empty__ynvHc","title":"EmptyList_title__2esT5","description":"EmptyList_description__VLUix"};